import { CHARACTER_VISIBILITY } from "@next-platform/client-common-core";

/**
 * Check for visibility conflicts between group and member selected for the group.
 * @param groupVisibility
 * @param memberVisibility
 * @returns
 */
export function hasVisibilityConflict(groupVisibility: string, memberVisibility: CHARACTER_VISIBILITY): boolean {
  if (groupVisibility === CHARACTER_VISIBILITY.PUBLIC) {
    return memberVisibility !== CHARACTER_VISIBILITY.PUBLIC;
  }
  if (groupVisibility === CHARACTER_VISIBILITY.HIDDEN) {
    const allowedVisibilities = [CHARACTER_VISIBILITY.PUBLIC, CHARACTER_VISIBILITY.HIDDEN];
    return !allowedVisibilities.includes(memberVisibility);
  }
  return false;
}
